<template>
  <div id="app" class="wrapper">
    <navigation-bar></navigation-bar>
    <transition name="component-fade" mode="out-in">
      <router-view id="content"></router-view>
    </transition>
    <custom-footer></custom-footer>
  </div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'App',
  components: {
    'navigation-bar': NavigationBar,
    'custom-footer': Footer
  }
}
</script>

<style>
#content{
  grid-area: content;
}
.slide-leave-active, .slide-enter-active {
  transition: 1s ease;
}
.slide-enter {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@-webkit-keyframes rubberBand {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes rubberBand {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.rubberBand {
  -webkit-animation-name: rubberBand;
  animation-name: rubberBand;
}

html{
  background-color: #383838 !important;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto !important;
}
body{
  background-color: #383838 !important;
}
p{
  text-align: left;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
footer {
    grid-area: footer;
}
.wrapper {
height: 100vh;
display: grid;
grid-template-rows: 60px 1fr 30px;
grid-template-columns: auto;
grid-template-areas:
  "navbar"
  "content"
  "footer"
}

#navbar{
  grid-area: navbar;
  height:60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

nav{
  display: flex;
  padding-right: 10px;
}

#navbar nav > a{
  line-height: 60px;
  height: 60px;
}

#navbar *{
max-height: 60px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue